// @flow
import React, { Component } from 'react';

import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';

import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';
import FeatureToggle from 'components/FeatureToggle';

import { getFeatureColor } from 'utils/mapStyle';
import { PROP_SHEET_FIELDS, AIRSPACE_USE_TYPES } from 'utils/propSheet';

const getStyles = ({ feature }) => ({
  iconCell: {
    width: '10%',
    paddingLeft: 16,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    textAlign: 'center',
  },

  icon: {
    backgroundColor: getFeatureColor(feature),
    color: 'white',
  },

  headerCell: {
    width: '27%',
    fontWeight: 'bold',
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 0,
  },

  valueCell: {
    width: '63%',
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 0,
    paddingRight: 16,
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },

  chip: {
    marginBottom: 4,
  },
});

const renderProperty = (fieldDef, fieldValue, feature) => {
  try {
    return fieldDef.content(fieldValue, feature);
  } catch (e) {
    return fieldValue;
  }
};

export default ({ feature, isMobile, isFollowing }) => {
  if (!feature) {
    return null;
  }

  const styles = getStyles({ feature });
  const fieldDefs = PROP_SHEET_FIELDS[feature.type];

  return (
    <Table selectable={false}>
      <TableBody displayRowCheckbox={false}>
        {Object.keys(fieldDefs)
          .filter(
            key =>
              isMobile && feature.type === 'ac' && isFollowing
                ? ['overlaps', 'nearby_aircraft'].includes(key)
                : true
          )
          .map(field => {
            const fieldDef = fieldDefs[field];
            const fieldValue = renderProperty(
              fieldDef,
              feature[field],
              feature
            );

            const fieldRow = fieldValue ? (
              <TableRow key={`tr-${field}`}>
                {isMobile ? null : (
                  <TableRowColumn
                    key={`th-icon-${field}`}
                    style={styles.iconCell}
                  >
                    <Avatar
                      style={styles.icon}
                      color={styles.icon.color}
                      size={32}
                      icon={
                        <FontIcon className="material-icons">
                          {fieldDef.icon}
                        </FontIcon>
                      }
                    />
                  </TableRowColumn>
                )}

                <TableRowColumn
                  key={`th-header-${field}`}
                  style={styles.headerCell}
                >
                  {fieldDef.label}
                </TableRowColumn>

                <TableRowColumn
                  key={`td-value-${field}`}
                  style={styles.valueCell}
                >
                  {fieldValue}
                </TableRowColumn>
              </TableRow>
            ) : null;

            return fieldDef.featureFlag ? (
              <FeatureToggle flag={fieldDef.featureFlag}>
                {fieldRow}
              </FeatureToggle>
            ) : (
              fieldRow
            );
          })}
      </TableBody>
    </Table>
  );
};



// WEBPACK FOOTER //
// ./components/PropSheet/Table.js